module.exports = __webpack_public_path__ + "static/media/01_A1_02.2b50e989.png";